<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="5" />
            <div class="box5" style="overflow: hidden;min-height: 900px;position: relative;">
                <div class="box6">我的收藏</div>
                <div class="box7"></div>
                <div class="box8">
                    <div style="overflow: hidden; margin-top: 1%">
                        <div class="box9" style="margin-left: 0; color: #666">品牌选择</div>
                        <div @click="changPinpai(index)" :class="['box9', pinpai_index == index ? 'top_active' : '']" v-for="(item, index) in pinpai" style="color: #333">
                            {{ item }}
                        </div>
                    </div>
                    <div class="box10"></div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="box9" style="margin-left: 0; color: #666">收藏时间</div>
                        <div @click="changShijian(index)" :class="['box9', shijian_index == index ? 'top_active' : '']" v-for="(item, index) in shijian" :key="index" style="color: #333">
                            {{ item.txt }}
                        </div>
                    </div>
                </div>

                <div style="overflow: hidden; margin-top: 2%">
                    <div style="overflow: hidden">
                        <div class="box11" style="float: left;cursor: pointer;" @click="piliangshangchu">批量操作</div>
                        <!-- <div style="float: left; margin-left: 2%; margin-top: 1%">
              <a-checkbox @change="onChange"> 全选 </a-checkbox>
            </div>
            <div style="float: left; margin-left: 2%; margin-top: 1%">

              <img src="../assets/shoucang.png" style="width: 13px; height: 13px;" alt="">
              <span>取消收藏</span>
            </div> -->
                        <div style="width: 50%; height: 100%; float: right">
                            <div class="box12" style="cursor: pointer">清空已失效商品</div>
                            <a-input-search placeholder="请输入CAS号、分子式、品牌、品名" style="float: right; width: 300px" @search="onSearch" />
                        </div>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <a-row :gutter="16">
                            <a-col class="gutter-row" :span="8" :key="index" v-for="(item, index) in list">
                                <div class="gutter-box box13" @click="to_goods_details(item.goodsId)">
                                    <div class="box14" style="text-align: left">{{ item.goodsName }}</div>
                                    <div style="overflow: hidden; margin-top: 4%">
                                        <img :src="'/api/file/preview/' + item.cover" style="width: 100px; height: 100px; float: left" alt="" />
                                        <div style="float: left; margin-left: 2%; float: left">
                                            <div style="margin-left: 4%; text-align: left">
                                                <div class="box15">
                                                    <div class="siderbarTitle" style="margin-top: 10px;">品牌：{{ item.brand }}</div>
                                                    <div class="siderbarTitle" style="margin-top: 10px;">CAS号：{{ item.casNum }}</div>
                                                </div>
                                                <div class="box16" style="margin-top: 10px;">立即购买</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="close_box" @click="shanchu(item)">x</div>
                                </div>
                            </a-col>
                        </a-row>
                        <div v-if="list.length == 0" style="margin-top: 40px; text-align: center">
                            没有记录~
                        </div>
                    </div>
                </div>

                <!--
                  <div style="position: absolute; bottom: 2%; width: 100%;">
          <div style="margin: auto;">
            <a-pagination show-quick-jumper :default-current="1" :total="totalPages*10" @change="fenye_onChange" />

          </div>
        </div>
         -->

                <div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
                    <a-pagination show-quick-jumper :default-current="1" :total="totalPages * 10" @change="fenye_onChange" />
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import qs from 'qs';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            totalPages: 1, //总页数
            list: [],
            pinpai_index: 0,
            shijian_index: 0,
            pinpai: ['全部'],
            shijian: [
                //   "", "", "", "", ""
                { txt: '全部', id: null },
                { txt: '一个月内', id: 1 },
                { txt: '三个月内', id: 3 },
                { txt: '六个月内', id: 4 },
                { txt: '一年内', id: 12 }
            ],
            search: '',
            page: 0
        };
    },
    methods: {
        fenye_onChange(e) {
            this.page = e;
            this.get_search_favorites();
        },
        //   搜索
        onSearch(e) {
            this.search = e;
            this.get_search_favorites();
        },
        //   更新数据
        get_search_favorites() {
            let obj = {
                search: this.search,
                page: this.page
            };
            if (this.shijian[this.shijian_index].id) {
                obj.time = this.shijian[this.shijian_index].id;
            }
            this.api.get_search_favorites(obj).then(res => {
                if (res.ok) {
                    this.list = res.data.content
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //   查询品牌
        get_favorites_searchBrand() {
            this.api.get_favorites_searchBrand().then(res => {
                if (res.ok) {
                    res.data.forEach(element => {
                        this.pinpai.push(element);
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //   删除方法
        delete_favorites(id) {
            console.log(id.join(','));
            const ids = id.join(',')
            const data = {
                ids:ids
            }
            this.api.delete_favorites(data).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                    this.get_list();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 批量删除
        piliangshangchu() {
            const that = this;
            let uuids = [];
            this.list.forEach(element => {
                uuids.push(element.uuid);
            });
            console.log(uuids.join(','));
            that.$confirm({
                title: `是否清空全部收藏?`,
                onOk() {
                    // uuids
                    that.api.delete_favorites(uuids.join(',')).then(res=>{
                        if(res.ok){
                            that.get_search_favorites()
                        }
                    });
                }
            });
        },
        // 去商品详情页
        to_goods_details(e) {
            this.$router.push('/goods_details?uuid=' + e);
        },
        // 删除
        shanchu(e) {
            const that = this
            that.$confirm({
                title: `是否删除收藏${e.goodsName}?`,
                onOk() {
                    // e.uuid
                    that.api.delete_favorite(e.uuid).then(res=>{
                        if(res.ok) {
                            that.get_search_favorites()
                        }
                    })
                }
            });
        },
        changPinpai(e) {
            this.pinpai_index = e;
            this.get_search_favorites();
        },
        changShijian(e) {
            this.shijian_index = e;
            this.get_search_favorites();
        },
        // 商品列表
        get_list() {
            this.api.get_favorites().then(res => {
                console.log(this.list);
                this.list = res.data.content;
                this.totalPages = res.data.totalPages;
            });
        }
    },
    created() {
        this.get_list();
        this.get_favorites_searchBrand();
    }
};
</script>

<style scoped>
.siderbarTitle{
  /* display: inline-block; */
  width: 150px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
 .siderbarTitle:hover{
      overflow: visible;
      animation: 3s siderbar linear infinite normal;
      z-index: 0;
  }
.box13:hover .close_box {
    display: block;
}
.box13:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-5px);
    transition: all 1s;
}
.close_box {
    width: 20px;
    transition: all 1s;
    height: 20px;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
    line-height: 20px;
    color: #fff;
    background: #ede9e9;
    display: none;
}
.ant-input-affix-wrapper {
    border: 1px solid #ede9e9;
    border-radius: 5px;
    outline: none;
}
.top_active {
    background: #2b9a34 !important;
    color: #fff !important;
    padding: 0 10px;
}
.box16 {
    width: 80px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-top: 4%;
}
.box15 {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.box14 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}
.box13 {
    width: 100%;
    height: 167px;
    background: #ffffff;
    border: 1px solid #ede9e9;
    padding: 2%;
    position: relative;
    margin-top: 20px;
    cursor: pointer;
}
.box12 {
    width: 120px;
    height: 32px;
    border: 1px solid #ede9e9;
    float: left;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
    line-height: 32px;
}
.box11 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
    line-height: 32px;
}
.box10 {
    width: 100%;
    height: 1px;
    border: 1px dashed #e8e6e6;
    margin-top: 2%;
}
.box9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
    margin-left: 2%;
    cursor: pointer;
}
.box8 {
    width: 100%;
    height: 130px;
    border: 1px solid #e8e6e6;
    margin-top: 2%;
    padding: 2%;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/collection.vue